<div class="message-list-panel">
  <p class="govuk-hint" *ngIf="loading()">Načítavam rozpracované správy…</p>

  <div class="govuk-error-summary" role="alert" *ngIf="error()">
    <div class="govuk-error-summary__body">
      <p class="govuk-body">{{ error() }}</p>
    </div>
  </div>

  <p class="govuk-hint govuk-!-margin-bottom-2" aria-live="polite" *ngIf="!loading() && totalCount() > 0">
    Zobrazené {{ rangeStart() }}–{{ rangeEnd() }} z {{ totalCount() }} · Strana {{ page() }} / {{ pages() }}
  </p>

  <div *ngIf="!loading() && headers().length" class="app-list-container">
    <ul class="govuk-list govuk-!-margin-bottom-0">
      <li *ngFor="let draft of headers()" class="app-item govuk-!-padding-2">
        <div class="app-message-title" 
             (click)="selectDraft(draft)"
             [attr.role]="'button'"
             [attr.tabindex]="0"
             [attr.aria-label]="'Upraviť správu: ' + (draft.subject || '(Bez predmetu)')"
             (keydown.enter)="selectDraft(draft)"
             (keydown.space)="selectDraft(draft); $event.preventDefault()">
          {{ draft.subject || '(Bez predmetu)' }}
        </div>
        <div class="govuk-hint app-hint govuk-!-margin-top-1">
          Pre: {{ formatRecipient(draft.recipientEdeskUri) }}
          <span *ngIf="draft.createdAt" class="date-with-icon">
            <img src="assets/icons/calendar.svg" class="calendar-icon" width="14" height="14" alt="" aria-hidden="true">
            {{ formatDate(draft.createdAt) }}
          </span>
        </div>
        <div class="govuk-!-margin-top-1">
          <strong *ngIf="draft.isSigned" class="govuk-tag govuk-tag--green">
            PODPÍSANÉ
          </strong>
          <span *ngIf="draft.attachmentCount > 0" class="govuk-hint govuk-!-margin-left-2">
            📎 {{ draft.attachmentCount }} {{ draft.attachmentCount === 1 ? 'príloha' : (draft.attachmentCount < 5 ? 'prílohy' : 'príloh') }}
          </span>
        </div>
      </li>
    </ul>
  </div>

  <div class="govuk-inset-text" *ngIf="!loading() && headers().length === 0">
    Nemáte žiadne rozpracované správy.
  </div>

  <nav *ngIf="!loading() && totalCount() > 0" class="app-pagination govuk-!-margin-top-3" role="navigation"
    aria-label="Stránkovanie">

    <button type="button" class="app-pagination__button" 
            [disabled]="!canGoFirst()" 
            (click)="firstPage()" 
            title="Prvá strana">
      ««
    </button>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canPrev()" 
            (click)="prevPage()" 
            title="Predchádzajúca strana">
      «
    </button>

    <div class="app-pagination__numbers">
      <ng-container *ngFor="let p of pagesArray()">
        <button *ngIf="p !== '...'" 
                type="button" 
                class="app-pagination__number" 
                [class.app-pagination__number--current]="p === page()"
                (click)="gotoPage($any(p))">
          {{ p }}
        </button>
        <span *ngIf="p === '...'" class="app-pagination__ellipsis">...</span>
      </ng-container>
    </div>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canNext()" 
            (click)="nextPage()" 
            title="Ďalšia strana">
      »
    </button>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canGoLast()" 
            (click)="lastPage()" 
            title="Posledná strana">
      »»
    </button>
  </nav>
</div>
